module.exports = __webpack_public_path__ + "img/6545.bb706959.jpg";